export default __webpack_public_path__ + "static/illu_call-93f8ca2e82a3b40ecbf6f9f8a46d6911.png";